export const FEEDBACK_TYPE = {
  NPS: 'NPS',
  CSAT: 'CSAT',
};

export const CSAT_NPS_FEEDBACK_OBJ = {
  orderId: null,
  overall: { rating: null },
  food: [
    // {
    //   rating: 2,
    //   productId: 4075,
    //   // tags: [],
    //   ratedTags: ['Taste', 'Packaging'],
    //   menuCode: ''
    // }
  ],
  // delivery: { rating: null, tags: [], ratedTags: [] }
  delivery: {},
  deliveryRatings: [],
  comments: '',
  showShimmer: true,
  templateApiData: {},
  ordering: {},
  submitApiResponse: {
    // id: '63fde97aab46a23cd413e6ff',
    // orderId: 'mcOotj6tycMBlYRBBbAywXkJgWa9CYULWnddPS-adm8',
    // ticketMessage: null,
    // feedbackAlreadySubmitted: false,
    // message: null,
    // additionalFeedback: {
    //   title: 'What motivated you to share your experience?',
    //   subTitle:
    //     'Your feedback will help us understand how our customers like to respond.',
    //   tags: [
    //     'Timely reminder for sharing your experience',
    //     'Store/ Delivery person requested'
    //   ]
    // }
  },
  showThankyouScreen: false,
  showLoaderAnimation: false,
  showTickAnimation: false,
  nps: {
    orderId: null,
    overall: { rating: null },
    food: [
      // {
      //   rating: 2,
      //   productId: 4075,
      //   // tags: [],
      //   ratedTags: ['Taste', 'Packaging'],
      //   menuCode: ''
      // }
    ],
    // delivery: { rating: null, tags: [], ratedTags: [] }
    delivery: {},
    comments: '',
    showShimmer: true,
    templateApiData: {},
    ordering: {},
    submitApiResponse: {
      // id: '63fde97aab46a23cd413e6ff',
      // orderId: 'mcOotj6tycMBlYRBBbAywXkJgWa9CYULWnddPS-adm8',
      // ticketMessage: null,
      // feedbackAlreadySubmitted: false,
      // message: null,
      // additionalFeedback: {
      //   title: 'What motivated you to share your experience?',
      //   subTitle:
      //     'Your feedback will help us understand how our customers like to respond.',
      //   tags: [
      //     'Timely reminder for sharing your experience',
      //     'Store/ Delivery person requested'
      //   ]
      // }
    },
    showThankyouScreen: false,
    showLoaderAnimation: false,
    showTickAnimation: false,
  },
  valueForMoney: [],
  tempDeliveryRating: null,
};
